export const ENVIRONMENT = {
  apiUrl: process.env.API_URL || '',
  defaultApiToken: process.env.API_TOKEN || '',
  tenant: process.env.TENANT || '',
  appEnv: process.env.NODE_ENV || 'production',
} as const;
